export interface GetSynonymGroupRequest {
  group: number
}

export function GetSynonymGroupRequestToJSON(
  value: GetSynonymGroupRequest
): any {
  return {
    group: value.group !== 0 ? value.group : undefined
  }
}
